import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Keyfeature() {
  return (
    <section className="key_feature text_white">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Key <span style={{ color: "#DC3C2A" }}>Features</span>
            </h2>
            <p>
              Below are the primary features incorporated in MoCuts Pro – a
              one-of-a-kind platform for booking barbers and beauticians online
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="key_box">
              <h4>Live Tracking through GPS</h4>
              <p>
                MoCuts Pro enables customers to track the live location of
                service providers through GPS. This feature helps customers
                search for nearby service providers through GPS and gives them
                an estimated arrival time using advanced algorithms once they
                book any service.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="key_box">
              <h4>Online Payment Integration</h4>
              <p>
                As people prefer debit cards and e-wallets for purchasing
                products and services online, our client wanted to integrate
                one-click online payment gateways. People can add debit cards or
                link e-wallets and perform seamless in-app transactions to pay
                service providers.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="key_box">
              <h4>In-App Messaging & Calling</h4>
              <p>
                MoCuts Pro has in-app messaging and calling features to enhance
                customer experience. This feature enables customers to
                communicate with the service providers without sharing their
                contact details. Customers can also access the schedules of
                barbers and beauticians and book their slots accordingly.
              </p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-4"
          >
            <StaticImage
              src="../../../images/case-studies/mocuts/feature_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1601}
              height={382}
            />
          </Col>
        </Row>
      </Container>
      <div className="key_red">
        <p>
          MoCuts Pro is an online marketplace for booking registered barbers,
          beauticians, and other day-to-day barber services.
        </p>
      </div>
    </section>
  );
}

export default Keyfeature;
